import { useState, useEffect } from 'react'

const navItems = [
  { label: '센터 소개', href: '#about' },
  { label: '핵심 가치', href: '#values' },
  { label: '주요 활동', href: '#activities' },
  { label: '비전', href: '#vision' },
  { label: '공지사항', href: '#notices' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    setMobileOpen(false)
    const el = document.querySelector(href)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-10 lg:px-16 h-16 md:h-20">
        <a href="#" className="flex items-center gap-3" onClick={(e) => {
          e.preventDefault()
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }}>
          <img
            src="https://public.readdy.ai/ai/img_res/60f21865-9619-478d-8c5a-068ce8f151ff.png"
            alt="다온심리상담센터 로고"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="메뉴"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <ul className="flex flex-col py-4 px-6 gap-4">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="block text-base font-medium text-foreground-800 hover:text-primary-600 transition-colors py-1"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  )
}